// "Export save" (DebugPanel; M7 Settings / v0.2 Export save): the §2.9 envelope of the running game built by
// the real SaveService on an in-memory store, so the export never touches (or rotates) the real save.
import { defsHashOf, SAVE_KEYS, type SaveMeta, SaveService } from '../save/SaveService.ts';
import { memoryStore } from '../save/storage.ts';
import type { SimDefs } from '../sim/defs.ts';
import type { SimState } from '../sim/state.ts';

export function saveEnvelopeText(
  defs: SimDefs,
  state: SimState,
  meta: SaveMeta,
  nowMs: number,
): string {
  const store = memoryStore();
  const svc = new SaveService(store, {
    defs,
    defsHash: defsHashOf(defs),
    now: () => nowMs,
    log: () => undefined,
  });
  svc.save(state, meta);
  const text = store.get(SAVE_KEYS.main);
  if (text === null) throw new Error('save export failed');
  return text;
}
